import '../filter_view.js.coffee'
import './survey_keyword_filter_view.js.coffee'

Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.SurveyKeywordFiltersView extends Backbone.View
  initialize: (@options = {}) ->
    @facet = @options.facet
    @survey = @facet['cem_surveys'][0]
    @searchQuery = @options.searchQuery

  isEmpty: ->
    not @survey.keywords

  render: ->
    @_renderTextFieldFilter(values) for values, _ in @survey.keywords if @survey.keywords
    @

  _renderTextFieldFilter: (values) ->
    @$el.append @_surveyKeywordFilterView(values).render().el

  _surveyKeywordFilterView: (values) ->
    new Monitoring.Views.SocialContents.Filters.SurveyKeywordFilterView
      searchQuery: @searchQuery
      facet: @facet
      name: values.code
      alias: values.name
      survey: @survey
